import { IGDPRConsentConfig } from "@desp-aas/desp-ui-fwk/src/types/gdpr";

export const GDPR_CONSENT_CONFIG: IGDPRConsentConfig = {
    "functional": {
        label: "Functional",
        shortDescription: "Cookies that are necessary for the website to function and cannot be switched off in our systems.",
        description: <>
            <p>These cookies are essential in order to use the website and its features.</p>
        </>,
        cookies: [{name: "access_token" }, {name: "refresh_token" }],
    },
    "analytics": {
        label: "Analytics",
        shortDescription: "Tracking cookies that are used to collect anonymous usage analytics of the website activity in order to improve the platform.",
        description: <>
            <p>Tracking cookies that are used to collect anonymous usage analytics of the website activity in order to improve the platform.</p>
        </>,
        cookies: [{ 
            name: "_pk_id", 
            duration: "13 Months", // 13 months
        },{
            name: "_pk_ses", 
            duration: "30 Minutes", // 30 minutes
        },{
            name: "_pk_ref", 
            duration: "6 Months", // 30 minutes
        },{
            name: "_pk_testcookie", 
            duration: "30 Minutes", // 30 minutes
        }],
    },
    // "telemetry": {
    //     label: "Telemetry",
    //     shortDescription: "Cookies that are used to collect anonymous logs and metrics of the user actions on the website.",
    //     description: <>
    //         <p>Cookies that are used to collect anonymous logs and metrics of the user actions on the website.</p>
    //         <p>These are used in order to reproduce errors on the platform in order to fix them rapidly. This greatly helps us improve the platform and the user experience.</p>
    //         <p>This does not use cookies</p>
    //     </>,
    //     cookies: [
    //         // Sentry cookies
    //         // { name: "_ga", duration: "2 Years" },
    //         // { name: "_ga_<container_id>", duration: "2 Years" },
    //         // 
    //     ],
    // },
}